const FAVORITES_COOKIE_NAME = '_noukaweb_favorites';
const FAVORITES_MAX_ITEMS = 200;
const FAVORITES_MAX_AGE = 60 * 60 * 24 * 365;
const FAVORITE_FEEDBACK_DURATION = 4000;

let favoriteFeedbackTimer;

function readCookie(name) {
  const prefix = `${name}=`;
  const cookie = document.cookie.split(';').map(value => value.trim()).find(value => value.startsWith(prefix));

  if (!cookie) return '';

  try {
    return decodeURIComponent(cookie.slice(prefix.length));
  } catch (_error) {
    return '';
  }
}

function favoriteIds() {
  return readCookie(FAVORITES_COOKIE_NAME)
    .split(',')
    .filter(id => /^\d+$/.test(id))
    .filter((id, index, ids) => ids.indexOf(id) === index)
    .slice(0, FAVORITES_MAX_ITEMS);
}

function removeUnavailableIds(ids) {
  const favoriteList = document.querySelector('[data-favorite-list]');
  if (!favoriteList) return ids;

  const validIds = favoriteList.dataset.validFavoriteIds.split(',').filter(Boolean);
  return ids.filter(id => validIds.includes(id));
}

function writeFavoriteIds(ids) {
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';

  if (ids.length === 0) {
    document.cookie = `${FAVORITES_COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax${secure}`;
    return;
  }

  const value = encodeURIComponent(ids.slice(0, FAVORITES_MAX_ITEMS).join(','));
  document.cookie = `${FAVORITES_COOKIE_NAME}=${value}; path=/; max-age=${FAVORITES_MAX_AGE}; SameSite=Lax${secure}`;
}

function updateButtons(ids) {
  document.querySelectorAll('[data-favorite-button]').forEach(button => {
    const isFavorite = ids.includes(button.dataset.productId);
    const label = button.querySelector('[data-favorite-label]');

    button.setAttribute('aria-pressed', isFavorite.toString());
    button.classList.toggle('is-favorite', isFavorite);
    button.title = isFavorite ? 'お気に入りから削除する' : 'お気に入りに登録する';
    if (label) label.textContent = isFavorite ? '登録済み' : 'お気に入り';
  });
}

function updateEmptyState() {
  const emptyState = document.querySelector('[data-favorite-empty-state]');
  if (!emptyState) return;

  const hasItems = document.querySelectorAll('[data-favorite-item]').length > 0;
  emptyState.classList.toggle('d-none', hasItems);
}

function showFeedback(added) {
  const feedbackElements = Array.from(document.querySelectorAll('[data-favorite-feedback]'));

  window.clearTimeout(favoriteFeedbackTimer);
  feedbackElements.forEach(element => {
    element.textContent = added ? 'お気に入りに登録しました。' : 'お気に入りから削除しました。';
    element.classList.remove('d-none', 'alert-success', 'alert-danger');
    element.classList.add(added ? 'alert-success' : 'alert-danger');
  });

  favoriteFeedbackTimer = window.setTimeout(() => {
    feedbackElements.forEach(element => {
      if (document.documentElement.contains(element)) element.classList.add('d-none');
    });
  }, FAVORITE_FEEDBACK_DURATION);
}

function toggleFavorite(button) {
  const productId = button.dataset.productId;
  let ids = favoriteIds();
  const wasFavorite = ids.includes(productId);

  if (wasFavorite && button.dataset.favoriteConfirm && !window.confirm(button.dataset.favoriteConfirm)) {
    button.blur();
    button.classList.remove('active');
    button.style.backgroundColor = '#fff';
    button.style.color = '#dc3545';
    return;
  }

  if (wasFavorite) {
    ids = ids.filter(id => id !== productId);
    document.querySelectorAll(`[data-favorite-item="${productId}"]`).forEach(item => item.remove());
  } else {
    ids = [productId, ...ids].slice(0, FAVORITES_MAX_ITEMS);
  }

  writeFavoriteIds(ids);
  updateButtons(ids);
  updateEmptyState();
  showFeedback(!wasFavorite);
}

function initializeFavorites() {
  const storedIds = favoriteIds();
  const ids = removeUnavailableIds(storedIds);
  if (ids.length !== storedIds.length) writeFavoriteIds(ids);

  updateButtons(ids);
  updateEmptyState();

  document.querySelectorAll('[data-favorite-button]').forEach(button => {
    if (button.dataset.favoriteInitialized === 'true') return;

    button.dataset.favoriteInitialized = 'true';
    button.addEventListener('click', () => toggleFavorite(button));
  });
}

document.addEventListener('turbolinks:load', initializeFavorites);
